<template>
  <div class="question-pool-view">
    <div v-if="question">
      <Question
        :question="question"
        @answered="handleAnswer"
        @failed="handleWrongAnswer"
      />
    </div>
    <Spinner v-if="loading" />
    <p
      v-else-if="
        $route.meta.pageType == 'wrong-questions' && questions.length == 0
      "
    >
      Alle Fragen korrekt beantworetet!
    </p>
  </div>
</template>

<script>
import Question from "@/components/Question.vue";
import Spinner from "@/components/Spinner.vue";
import axios from "@/http";
import hardest from "@/data/top_300_hard_questions.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "QuestionPoolView",
  components: { Question, Spinner },
  data() {
    return {
      question: null,
      questions: [],
      wrong: [],
      prevQuestion: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["tokenHeader"]),
  },
  watch: {
    "$route.meta.poolUrl": function (url) {
      this.loadPool();
    },
    "$store.state.user": function (o, n) {
      if (this.$route.meta.pageType === "wrong-questions") {
        if (n) this.$router.push("/");
      }
    },
  },
  async mounted() {
    this.setPageType(this.$route.meta.pageType);
    if (this.$route.meta.pageType === "hard-questions") {
      //console.log(ids);
      this.questions = hardest.ids;
      this.loadRandomQuestion();
    } else {
      this.loadPool();
    }
  },
  methods: {
    async loadPool() {
      this.loading = true;
      try {
        let result = await axios.get(
          process.env.VUE_APP_FLL_ROOT_API + this.$route.meta.poolUrl,
          {
            headers: {
              ...this.tokenHeader,
            },
          }
        );
        this.questions = result.data;
        this.loading = false;
        this.loadRandomQuestion();
      } catch (error) {
        // TODO: handle error
        console.error(error);  // eslint-disable-line
      }
    },
    loadRandomQuestion() {
      let roll = Math.floor(Math.random() * 11);
      let randKey = 0;
      if (roll >= 5 && this.wrong.length > 0) {
        let rndFail = this.wrong[Math.floor(Math.random() * this.wrong.length)];
        if (rndFail != this.prevQuestion) {
          randKey = rndFail;
        }
      }
      if (randKey == 0) {
        randKey =
          this.questions[Math.floor(Math.random() * this.questions.length)];
      }
      this.loadQuestion(randKey);
    },
    async loadQuestion(id) {
      try {
        this.loading = true;
        let result = await axios.get(
          process.env.VUE_APP_FLL_ROOT_API + "/questions/" + id,
          {
            headers: {
              ...this.tokenHeader,
            },
          }
        );
        this.question = result.data;
        this.questions.push(result.data);
        this.key = Math.random();
        this.loading = false;
      } catch (error) {
        // TODO: handle error
        console.error(error);  // eslint-disable-line
        this.loading = false;
      }
    },
    handleAnswer() {
      if (this.wrong.includes(this.question.id)) {
        this.wrong = this.wrong.filter((id) => {
          return id != this.question.id;
        });
      }
      this.prevQuestion = this.question.id;
      this.question = null;
      this.loadRandomQuestion();
    },
    handleWrongAnswer() {
      if (!this.wrong.includes(this.question.id)) {
        this.wrong.push(this.question.id);
      }
      this.prevQuestion = this.question.id;
      this.question = null;
      this.loadRandomQuestion();
    },
    ...mapActions(["setPageType"]),
  },
};
</script>

<style lang="scss" scoped>
.question-view {
  .question-input-container {
    .question-id-input-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;

      input {
        margin-right: 10px;
        color: #000000;
        padding: 2px;
      }
    }
    h2 {
      color: #000000;
    }
    table {
      margin-top: 20px;
      border-collapse: collapse;

      tr {
        cursor: pointer;
        th {
          text-align: left;
          font-weight: bold;
          border-bottom: 2px solid $blue;
        }
        td,
        th {
          color: #000000;
          vertical-align: top;
          padding: 4px 2px;
        }
        td {
          border-bottom: 1px solid $blue;
        }
        .q-id {
          text-align: right;
          padding-right: 10px;
        }
        &:hover {
          td {
            background: $green;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
